import { BsArrowRightCircleFill } from 'react-icons/bs';
import { NavLink } from 'react-router-dom';

const EventNameCard = ({ defaultImg, data }) => {
  return (
    <section className='DBlock min-h-full menuImgCard'>
      <div className='relative h-full'>
        {data && (
          <NavLink to={data?.url}>
            <BsArrowRightCircleFill
              className='absolute top-2 right-2 z-30'
              size={25}
              color='white'
            />
          </NavLink>
        )}
        <img
          className='object-cover w-full menuImg'
          src={`${data?.submenuImg ? data?.submenuImg : defaultImg}`}
          alt='submenuImg'
        />
        <div className='overlay'></div>
        {data && (
          <div className='text-right absolute bottom-6 left-0'>
            <p className='text-white text-base uppercase tracking-wider font-medium'>
              AUGUST 19-2019
            </p>
            <h3 className='text-2xl text-white font-bold capitalize'>
              {data?.label} Event
            </h3>
            <div className='heading my-1'></div>
            <p className='text-white text-base capitalize tracking-wider font-medium'>
              <span className='font-semibold'>By:</span> De evente events
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default EventNameCard;
